import { isCustomPatternLayer, type Layer } from '@pn/core/domain/layer';
import { generatePatternLayerId } from '@pn/core/domain/workspace';
import { assert } from '@pn/core/utils/assert';
import { toWebGLRGBA } from '@pn/services/color/webglColor';
import { PolygonPatternCustomLayer } from '@pn/services/map/mapbox/custom/PolygonPatternCustomLayer';
import { patternModules } from '@pn/services/map/mapbox/custom/patterns';
import { generateEmptyGeoJsonFeatureCollection } from '@pn/services/utils/geojson';

export function buildPatternLayer(layer: Layer): PolygonPatternCustomLayer {
  assert(isCustomPatternLayer(layer), 'Layer must be a custom pattern layer');

  const customLayer = new PolygonPatternCustomLayer(
    generatePatternLayerId(layer.id),
    generateEmptyGeoJsonFeatureCollection() as any, // broken TS (works fine in TS v7)
    {
      pattern: {
        type: layer.metadata.type,
        props: {
          ...layer.metadata,
          color: toWebGLRGBA(layer.style.color),
        },
        module: patternModules[layer.metadata.type],
      },
    }
  );

  return customLayer;
}
